import { ApprovalConsiderationAnnounceFiveComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceFiveComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function ApprovalConsiderationAnnounceFiveContainer() {
    const titleName = "รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (ชอ.4-1)";
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ApprovalConsiderationAnnounceFiveComponent />
            <Footer />
        </div>

    )
}